<template>
    <div class="machinelocations">
        <b-modal size="xl" no-close-on-backdrop title="Edit Location" class="modal-success" v-model="editLocationDlg" ok-variant="success" :ok-only="true" ok-title="Close"
            @ok="editLocationDlg=false">
            <b-container fluid>
                <b-card title="Edit machine location">
                    <b-form @submit.prevent="onSubmitTeam">
                        <b-container fluid class="dlg">
                            <b-row v-for="l of locations" :key="l.startdate">
                                <b-col cols="4">
                                    <b-form-group id="input-group-1" label="Start Date" label-for="start-date">
                                        <b-form-input id="start-date" v-model="l.fs" type="date" readonly />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="7">
                                    <b-form-group id="input-group-2" label="Location" label-for="input-location">
                                        <b-form-input id="input-location" v-model="l.location" type="text" readonly />
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-button size="sm" class="trash" variant="danger" @click="deleteLocation(l)"><v-icon name="trash" scale="1" /></b-button>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="4">
                                    <b-form-group id="input-group-1" label="Start Date" label-for="start-date">
                                        <b-form-input id="start-date" v-model="newstartdate" type="date" />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="7">
                                    <b-form-group id="input-group-2" label="Location" label-for="input-location">
                                        <b-form-input id="input-location" v-model="newlocation" />
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-button size="sm" class="trash" variant="info" @click="addLocation()"><v-icon name="plus" scale="1" /></b-button>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-form>
                </b-card>
            </b-container>
        </b-modal>
        <b-card title="Machine Location">
            <b-row v-for="r in locations" :key="r.startdate" class="locations">
                <b-col cols="3">{{ formatDate(r.startdate) }}<hr></b-col>
                <b-col cols="3">{{ formatDate(r.enddate) }}<hr></b-col>
                <b-col cols="6">{{ r.location }}&nbsp;<hr></b-col>
            </b-row>
            <b-button block @click="onEditLocation()">&#x270E;</b-button>
        </b-card>
    </div>
</template>

<script>
import { API } from "@/api.js";

export default {
    data: function () {
        return {
            locations: [],
            editLocationDlg: false,
            newstartdate: null,
            newlocation: null,
        };
    },
    name: "Locations",
    props: { },
    async mounted() {
        this.getLocations();
        console.log("mounted locations:", this.locations);
    },
    async beforeUpdate() { },
    computed: {
        section(){
            return this.$store.getters.section
        },
        machine() {
            return this.$store.getters.machine;
        },
     },
    watch: {
        machine: async function() {
            this.getLocations();
        }
     },
	methods: { 
        async getLocations(){
            this.locations = (await API.unitLocation(this.machine.codice)).map(l => ({ ...l, fs: l.startdate.split("T")[0], fe: l.enddate ? l.enddate.split("T")[0] : null}));
        },
        async deleteLocation(p) {
            console.log("delete location:", p);
            await API.unitLocationDel(this.machine.codice,this.formatDate(p.startdate));
            this.getLocations();
        },
        async addLocation() {
            console.log("add location:", this.newstartdate, this.newlocation);
            if(!this.newstartdate || !this.newlocation)
                return;
            await API.unitLocationAdd(this.machine.codice,this.newstartdate, this.newlocation,this.section);
            this.newstartdate = null
            this.newlocation = null
            this.getLocations();
        },
        onEditLocation(){
            this.editLocationDlg = true;
        },
        formatDate(d) {
            return d ? d.split("T")[0] : '*';
        },
    },
};
</script>

<style scoped>
hr {
    margin: 2px;
}
div.machinelocations button {
    background-color: #9a240d !important;
    border-color: #9a240d !important;
    margin-bottom: 10px;
}

div.machinelocations button:hover {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5) !important;
}

div.machinelocations button:active {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5) !important;
}
div.card button {
    width: 24px;
    height: 24px;
    padding: 0px;
    /* padding-bottom: 0px; */
    position: absolute;
    top: 25px;
    right: 20px;
}
</style>
